var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (errors, title) {pug_html = pug_html + "\u003Cdiv class=\"feedback feedback-error margin-top-double\"\u003E\u003Cdiv class=\"feedback-title\"\u003E" + (pug.escape(null == (pug_interp = title || 'Ops! Alguma coisa está errada.') ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cul class=\"list\"\u003E";
// iterate errors
;(function(){
  var $$obj = errors;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var error = $$obj[pug_index0];
pug_html = pug_html + "\u003Cli class=\"list-item color-text\"\u003E" + (pug.escape(null == (pug_interp = error) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var error = $$obj[pug_index0];
pug_html = pug_html + "\u003Cli class=\"list-item color-text\"\u003E" + (pug.escape(null == (pug_interp = error) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E";}.call(this,"errors" in locals_for_with?locals_for_with.errors:typeof errors!=="undefined"?errors:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined));;return pug_html;};
module.exports = template;